export const ShippingConfig = {
  minQuantityInOnePackage: 1,
  maxQuantityInOnePackage: 99,
  defaultQuantityInOnePackage: 99, // default value for all categories

  ZasilkovnaPickupPoint: {
    maxSideLength: 120, // in cm
    maxSidesSumLength: 150, // in cm
    maxWeight: 10, // in kg
    insuranceLimit: 20000, // in CZK
  },
};
